// Shared labels/formatters for the skilled professional review screens

export const ROLE_LABELS = {
    chartered_accountant: { short: 'CA', long: 'Chartered Accountant / Financial Auditor' },
    legal: { short: 'Legal', long: 'Legal Practitioner / Compliance Expert' },
    me_research: { short: 'M&E / Research', long: 'M&E / Research Specialist' },
    other: { short: 'Other', long: 'Other' }
};

export const DOCUMENT_LABELS = {
    passport: 'Passport',
    national_id: 'National ID',
    driving_license: "Driver's license",
    address_proof: 'Address proof',
    tax_document: 'Tax document',
    cv: 'CV',
    practising_certificate: 'Practising certificate',
    bar_enrolment: 'Bar enrolment',
    research_proof: 'Research proof',
    other_certification: 'Other certification',
    work_sample: 'Work sample'
};

// Which document types belong in each review section (matches the requirements document)
export const SECTION_DOCUMENTS = {
    identity: ['passport', 'national_id', 'driving_license', 'address_proof', 'tax_document'],
    credentials: ['cv'],
    certifications: ['practising_certificate', 'bar_enrolment', 'research_proof', 'other_certification'],
    track_record: ['work_sample']
};

export const REQUIREMENT_LABELS = {
    photo_id: 'Photo ID',
    address_proof: 'Address proof (within 3 months)',
    tax_id_number: 'Tax ID',
    tax_document: 'Tax document',
    cv: 'CV',
    linkedin_url: 'LinkedIn URL',
    role_categories: 'Role category',
    practising_certificate: 'Practising certificate',
    bar_enrolment: 'Bar enrolment',
    research_proof: 'Research proof',
    work_samples: 'Work samples (2–3)',
    references: 'References (2)',
    agreements: 'Agreements'
};

export function statusVariant(status) {
    switch (status) {
        case 'verified': return 'success';
        case 'submitted': return 'primary';
        case 'rejected': return 'danger';
        case 'pending': return 'warning';
        default: return 'secondary';
    }
}

export function formatDate(value) {
    if (!value) return '—';
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}
